import React, { PropsWithChildren } from 'react';
import { Box } from '@/ui-kit/box';
import styled from '@emotion/styled';
import { useGetPublicWebsite } from '@/features/website';
import {
  BLACK, mq, useThemeContext,
} from '@/features/theme';
import PlaceholderImage from '~/images/placeholder-image.png';
import { rgba } from 'polished';

const StyledHero = styled.div(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gap: '12px',

    [mq.sm]: { padding: '0 16px' },
  };
});

const HeroContainer = styled.div(() => {
  const theme = useThemeContext();

  return {
    padding: '8px 16px 8px 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    borderRadius: '50px',
    background: rgba(theme.primaryColor, 0.1),
  };
});

const HeroImage = styled.img(() => {
  return {
    flexShrink: 0,
    width: '40px',
    height: '40px',
    aspectRatio: '1/1',
    objectFit: 'cover',
    borderRadius: '50%',
  };
});

const HeroName = styled.div(() => {
  return {
    color: BLACK,
    fontFamily: 'Work Sans, sans-serif',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '150%',
  };
});

const HeroTitle = styled.div(() => {
  return {
    color: BLACK,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '150%',
  };
});

interface IHeroProps {
  className?: string;
  userId: string;
}

export const Hero = ({
  className,
  userId,
  children,
}: PropsWithChildren<IHeroProps>) => {
  const publicWebsiteQuery = useGetPublicWebsite({ userId });

  if (!publicWebsiteQuery.data?.configuration) {
    return (
      <StyledHero className={className}>
        {children}
      </StyledHero>
    );
  }

  return (
    <StyledHero className={className}>
      <HeroContainer>
        <HeroImage src={publicWebsiteQuery.data.configuration.layout.hero.image.value || PlaceholderImage} />
        <Box grow={1} direction="column" gap={0}>
          <HeroName>
            {publicWebsiteQuery.data.configuration.layout.hero.name.value}
          </HeroName>
          <HeroTitle>
            {publicWebsiteQuery.data.configuration.layout.hero.title.value}
          </HeroTitle>
        </Box>
      </HeroContainer>
      {children}
    </StyledHero>
  );
};
